import type { PartFittingView, PartReplacementIntervalView } from '@chukua/common';

const DASH = '—';
const dateFormat = new Intl.DateTimeFormat('en-KE', { dateStyle: 'medium', timeZone: 'UTC' });

/** The register shows the day a part was fitted, in UTC like the API's date filter. */
export function formatFittedDate(iso: string): string {
  return dateFormat.format(new Date(iso));
}

export function formatOdometer(km: number | null): string {
  return km === null ? DASH : `${new Intl.NumberFormat('en-KE').format(km)} km`;
}

export function workOrderLabel(row: Pick<PartFittingView, 'workOrderNumber'>): string {
  return `WO-${row.workOrderNumber}`;
}

/** What an interval shows for distance: unknown, not zero, when an odometer was not recorded. */
export function formatIntervalKm(km: PartReplacementIntervalView['km']): string {
  return km === null ? 'Unknown' : `${new Intl.NumberFormat('en-KE').format(km)} km`;
}

export function formatIntervalDays(days: number): string {
  return `${days} ${days === 1 ? 'day' : 'days'}`;
}

/** The type's expected life as one phrase for the interval's tooltip. */
export function describeExpectedLife({ expectedLifeKm, expectedLifeDays }: Pick<PartReplacementIntervalView, 'expectedLifeKm' | 'expectedLifeDays'>): string {
  const parts = [expectedLifeKm !== null && formatOdometer(expectedLifeKm), expectedLifeDays !== null && formatIntervalDays(expectedLifeDays)].filter(Boolean);
  return parts.length ? `Expected life ${parts.join(' or ')}` : 'No expected life set';
}
